import {
  formatApiDateTimeDisplay,
  formatDateOrDash,
} from '#/utils/date';
import { formatDisplayQty } from '#/utils/formatNumber';

function displayOrDash(value) {
  if (value == null || value === '') {
    return '—';
  }
  return value;
}

function formatQuantityDisplay(value) {
  if (value == null || value === '') {
    return '—';
  }
  return formatDisplayQty(value);
}

function resolveProductSubtitle(mtr) {
  if (!mtr) {
    return '—';
  }
  const label = [mtr.mtrNo, mtr.name].filter(Boolean).join(' ');
  return label || '—';
}

function resolveBomLabel(bom) {
  if (!bom) {
    return '—';
  }
  const codeVersion = [bom.code, bom.version].filter(Boolean).join(' · ');
  if (bom.name) {
    return codeVersion ? `${codeVersion} · ${bom.name}` : bom.name;
  }
  return codeVersion || bom.id || '—';
}

function resolveWarehouseName(warehouse) {
  return warehouse?.name ?? '—';
}

export function mapWorkOrderMeta(detail) {
  const quantity = detail?.quantity ?? {};

  return {
    code: detail?.workOrderNo || '-',
    status: detail?.status || '',
    productSubtitle: resolveProductSubtitle(detail?.mtr),
    createDate: formatApiDateTimeDisplay(detail?.record?.createdAt) || '—',
    reviseDate: formatApiDateTimeDisplay(detail?.record?.updatedAt) || '—',
    closeDate: formatApiDateTimeDisplay(detail?.history?.closedAt) || '—',
    scheduledStartDate: formatDateOrDash(detail?.scheduledStartDate),
    processingFactory: displayOrDash(detail?.processingFactory?.name),
    workWarehouse: resolveWarehouseName(detail?.workWarehouse),
    targetWarehouse: resolveWarehouseName(detail?.targetWarehouse),
    bomLabel: resolveBomLabel(detail?.bom),
    bomId: detail?.bom?.id ?? null,
    manufacturingQty: formatQuantityDisplay(quantity.manufacturingQty),
    completedQty: formatQuantityDisplay(quantity.completedQty),
    scrapQty: formatQuantityDisplay(quantity.scrapQty),
    cancelQty: formatQuantityDisplay(quantity.cancelQty),
    effectiveManufacturingQty: formatQuantityDisplay(quantity.effectiveManufacturingQty),
    issueReason: detail?.issueReason ?? '',
    remark: detail?.remark ?? '',
  };
}

export { displayOrDash };
